import { get } from 'lodash'
import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useUserReflections = ({ userId }) => {
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()

    const { data, isLoading } = useQuery(
        [cacheKeys.USER_REFLECTIONS, userId],
        () => api.get(url(endpoints.userReflections, {userId})),
        {
            staleTime: time.HOUR,
            enabled: Boolean(userId)
        }
    )

    return {
        userReflections: get(data, 'items', []),
        isLoadingUserReflections: isLoading
    }
}

export default useUserReflections
